import React from "react";
import { useState, useEffect } from "react";
import LandingHeader from "../components/LandingHeader";
import { SearchCircleIcon, SearchIcon } from "@heroicons/react/outline";
import ReactQuill from "react-quill"; // CommonJSimport
import EditorToolbar, { modules, formats } from "../components/EditorToolbar";
import { WithContext as ReactTags } from "react-tag-input";
import SearchQuestionHeader from "../components/SearchQuestionHeader";
import axios from "axios";
import moment from "moment";
import { toast } from "react-toastify";
import backendService from "../services.js/backendService";
import "react-toastify/dist/ReactToastify.css";
import { useBeforeunload, Beforeunload } from "react-beforeunload";
import toastProp from "../global/toastProps";
import { useNavigate } from "react-router-dom";

require("react-quill/dist/quill.snow.css");

const KeyCodes = {
  enter: 13,
};

function AskQuestionPage() {
  const navigate = useNavigate();
  const [tags, setTags] = useState([]);
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const handleDelete = (i) => {
    setTags(tags.filter((tag, index) => index !== i));
  };
  const handleAddition = (tag) => {
    setTags([...tags, tag]);
  };
  const delimiters = [KeyCodes.enter];
  const handleTagClick = (index) => {
    

    
  };

  const onClearAll = () => {
    setTags([]);
  };

  const onTagUpdate = (i, newTag) => {
    const updatedTags = tags.slice();
    updatedTags.splice(i, 1, newTag);
    setTags(updatedTags);
  };

  const handleSubmit = async (e) => {
    const id = toast.loading("Please wait...", { theme: "light" });
    await axios
      .post(
        `${process.env.REACT_APP_URL}/createquestion`,
        {
          title: title,
          body: body,
          tags: tags.map((tag) => tag.text),
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        }
      )
      .then((res) => {
        toast.update(id, toastProp("Question Created", true));
       
        navigate(`/question/${res.data.question._id}`);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setTitle("");
        setBody("");
        setTags([]);
      });
  };

  return (
    <div className="h-screen">
      {/* search question header */}
      <SearchQuestionHeader />
      {/* body  */}
      <body className="h-[90%] overflow-x-hidden overflow-y-auto chat__container">
        <div className="h-full ">
          {/* Question area */}
          <div className=" h-full ">
            {/* heading */}
            <div className="min-h-[10vh] sm:min-h-0 py-4 sm:py-6 md:py-8 flex items-center text-xl sm:text-2xl px-4 sm:px-6 md:px-8 lg:px-12 xl:pl-20">
              Ask Questions from public
            </div>
            {/* top question list */}
            <div className="w-full h-auto flex justify-center  ">
              {/* question card */}
              <div className="w-full px-2 sm:w-11/12 md:w-10/12 lg:w-9/12 xl:w-8/12 mx-auto">
                {/* question title */}
                <div className="w-full pb-8">
                  {" "}
                  <h3 className=" text-lg">
                    <a className="text-red">*</a>Title
                  </h3>
                  <p className="text-xs">
                    Be specific and imagine you’re asking a question to another
                    person
                  </p>
                  <div>
                    <input
                      type="text"
                      name="search"
                      id="search"
                      autoComplete="off"
                      className=" border-[1px] border-palette_color1 block text-sm w-full   py-2 px-3 bg-white appearance-none rounded-sm text-primary placeholder-secondary focus:outline-none focus:z-10 sm:text-sm"
                      placeholder="Title"
                      onChange={(e) => setTitle(e.target.value)}
                    />
                  </div>
                </div>

                {/* question body */}
                <div className="pb-8">
                  <h3 className="text-lg ">
                    <a className="text-red">*</a>Body
                  </h3>
                  <p className="text-xs">
                    Include all the information someone would need to answer
                    your question
                  </p>
                  <div>
                    <EditorToolbar />
                    <ReactQuill
                      className="h-auto"
                      theme="snow"
                      placeholder={"Write here..."}
                      modules={modules}
                      formats={formats}
                      onChange={(value) => {
                        setBody(value);
                      }}
                    />
                  </div>
                </div>

                {/* question tags */}
                <div className="pb-8">
                  <h3 className="text-lg">
                    <a className="text-red">*</a>Tags
                  </h3>
                  <p className="text-xs pb-2">
                    Add up to 5 tags to describe what your question is about
                  </p>
                  <ReactTags
                    tags={tags}
                    handleDelete={handleDelete}
                    handleAddition={handleAddition}
                    delimiters={delimiters}
                    handleTagClick={handleTagClick}
                    onClearAll={onClearAll}
                    onTagUpdate={onTagUpdate}
                    placeholder="Type here..."
                    minQueryLength={2}
                    maxLength={15}
                    autofocus={false}
                    allowDeleteFromEmptyInput={true}
                    autocomplete={true}
                    readOnly={false}
                    allowUnique={true}
                    allowDragDrop={true}
                    inline={true}
                    allowAdditionFromPaste={true}
                    editable={true}
                    clearAll={true}
                  />
                </div>
                {/* question submit */}
                <div className="pb-8 flex justify-end">
                  <button
                    className="py-2 px-4 sm:py-3 sm:px-6 rounded-md shadow font-semibold bg-palette_color1 hover:opacity-90 antialiased hover:subpixel-antialiased text-white"
                    onClick={async () => {
                     
                      if (
                        title.length > 0 &&
                        body.length > 0 &&
                        tags.length > 0
                      ) {
                        await handleSubmit();
                      } else {
                        toast.error("Please fill all the fields");
                      }
                    }}
                  >
                    {" "}
                    Submit Question
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </div>
  );
}
export default AskQuestionPage;
